import { PUT_REDUX_SHIPMENT_LIST } from '../../reducers/constants';

const putReduxAllShipments = (allShipments) => ({
  type: PUT_REDUX_SHIPMENT_LIST,
  allShipments,
});
export default putReduxAllShipments;
